/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as TaxLotService} from "../../../Services/TaxLotService";

export class TaxLotFieldViewer extends BaseFieldViewer {
	constructor() {
		super();

		this.setInitialState({
			taxLots: []
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		TaxLotService.Get()
			.then((x) => {
				this.setState({taxLots: x.result});
			});
	}

	@autobind
	getTaxLot() {
		return this.state.taxLots.find((x) => x.taxLotId == this.props.Value);
	}

	@autobind
	_render() {
		let taxLot = this.getTaxLot();

		return taxLot ? taxLot.parcelNumber : "N/A";
	}
}